import {inject, observer} from "mobx-react";
import Title from "js/components/core/SteppedPage/Title";
import Backdrop from "js/components/core/Backdrop";
import React from "react";
import Constraint from "js/components/Constraint";
import { url } from 'js/services/Network';
import AppState from 'js/stores/AppState';
import Button from 'js/components/Header/GuestNav/PanelMenu/Button';
import Spinner from 'js/components/core/ImageUploader/Spinner';
import Item from 'js/components/pages/MyItemsPage/ItemsList/Item';
import { Trail } from 'react-spring';
import ListContainer from 'js/components/pages/MyItemsPage/ItemsList/ListContainer';

export default inject('page')(
  observer( ({page}) => {
    async function onFileChange(event) {
      const selectedFile = event.target.files[0];

      const formData = new FormData();
      formData.append('file', selectedFile, selectedFile.name);
      formData.append('address', JSON.stringify(page.address));

      await page.uploadFile(formData);
      event.target.value = "";

      if(page.uploadFilesError) return;

      page.setSuccessUpload(true)
    }
    return (
      <>
        <Backdrop>
          <Title>Add Multiple Items</Title>
        </Backdrop>

        <Constraint>
          <div className="upload-instructions">
            <ul>
              <li><strong>Step 1:</strong> Download the Google sheet template</li>
              <li><strong>Step 2:</strong> Add the details of every item on a separate row</li>
              <li><strong>Step 3:</strong> Make sure you put the public url in image coloumn. You can create an url using free platforms like postimage, imgshare, etc.</li>
              <li><strong>Step 4:</strong> After all fields are filled, download the file as CSV</li>
              <li><strong>Step 5:</strong> Upload the file with <strong>.csv</strong> extension</li>
            </ul>

            <div className="buttons d-flex justify-content-between">
              <a
                href="https://docs.google.com/spreadsheets/d/1CCi5TB04s03kO9SPCX2Ybf94eQLhdQyZi6eoW8fa-hE/edit?usp=sharing"
                target="_blank"
                className="btn btn-pod btn-secondary">Download Template</a>
              <label for="file-to-upload">
                <span className="btn btn-pod btn-primary">Upload CSV</span>
                <input id="file-to-upload" type="file" onChange={onFileChange}/>
              </label>
            </div>


              {page.uploadFilesError ?
                <div className="error-message">
                  <p>There was an error in uploading the file. Please ensure that you keep the header name of the
                    templates unchanged and upload files with .csv extension only.</p>
                </div>
              : null}

              {page.isUploadingFiles ?
                <div className="d-flex justify-content-center mt-5">
                  <Spinner className="w-q" size={2} />
                </div> : null}

              {page.uploadSuccessed ?
                <div className="buttons d-flex justify-content-center mt-3"><Button
                  className="btn btn-pod btn-outline-success"
                  area="button"
                  onClick={event => {
                    event.preventDefault();
                    page.nextStep()
                  }}>
                  Next Step
                </Button></div>
                : null}

          </div>

        </Constraint>

        {/*<div className="mt-4 d-flex justify-content-center">*/}
          {/*{page.items.map(( item, index ) => {*/}
          {/*  return (*/}
          {/*    <Item key={index} item={item} endpoint={'checkout-page'} />*/}
          {/*  );*/}
          {/*})}*/}
          {/*<ListContainer >*/}
          {/*  <Trail native items={page.items} from={{ opacity: 0 }} to={{ opacity: 1 }} config={{ clamp: true }}>*/}
          {/*    {item => <Item item={item} endpoint={'status-page'} />}*/}
          {/*  </Trail>*/}
          {/*</ListContainer>*/}
          {/*<Trail native items={page.items} from={{ opacity: 0 }} to={{ opacity: 1 }} config={{ clamp: true }}>*/}
          {/*  {item => animation => <Item item={item} style={animation} endpoint={'checkout-page'} />}*/}
          {/*</Trail>*/}
        {/*</div>*/}

        <div className="mt-4 d-flex justify-content-center">
          <table className="table table-striped min-w-min">
            <thead className="bg-gray-50 bg-body">
            <tr className="shadow-2xl py-4">
              <th scope="col" className="px-6 py-3 text-left font-semibold text-lg text-pcr tracking-wider cursor-pointer">
                Name
              </th>
              <th scope="col" className="px-6 py-3 text-left font-semibold text-lg text-pcr tracking-wider cursor-pointer">
                Price ($)
              </th>
              <th scope="col" className="px-6 py-3 text-left font-semibold text-lg text-pcr tracking-wider cursor-pointer">
                Size
              </th>
              <th scope="col" className="px-6 py-3 text-left font-semibold text-lg text-pcr tracking-wider cursor-pointer">
                Picture URL
              </th>
            </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 text-pcr">
              {page.items.map(( item, index ) => {
                return (
                  <tr key={index}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                    <td>{item.size}</td>
                    <td>{item.images}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

      </>
    );
  })
);
